import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Confetti, MapPin, ArrowSquareOut } from "@phosphor-icons/react";
import InteractionsPanel from "@/components/InteractionsPanel";

export default function EventDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/events/${id}`);
        setEvent(data);
      } catch (e) {
        toast.error("Evento não encontrado");
        navigate("/eventos");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) return <div className="pt-32 text-center text-zinc-500 font-mono-accent text-xs">A CARREGAR...</div>;
  if (!event) return null;

  return (
    <div className="pt-20 max-w-4xl mx-auto px-5 lg:px-8 pb-24" data-testid="event-detail-page">
      <Link to="/eventos" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-6">
        <ArrowLeft size={16} weight="bold" /> Voltar aos eventos
      </Link>

      {event.image_url && (
        <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-8 border border-white/5">
          <img src={event.image_url} alt={event.title} className="w-full h-full object-cover" />
        </div>
      )}

      <div className="font-mono-accent text-xs text-[#F59E0B] mb-2 flex items-center gap-2">
        <Confetti size={14} weight="bold" /> EVENTO
      </div>
      <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">{event.title}</h1>

      <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-zinc-400">
        <div className="flex items-baseline gap-2">
          <span className="font-mono-accent text-xs text-zinc-500">DATA</span>
          <span className="font-display font-bold text-white">
            {new Date(event.event_date).toLocaleDateString("pt-PT", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
          </span>
        </div>
        {event.location && (
          <div className="flex items-center gap-1 text-sm">
            <MapPin size={14} weight="bold" /> {event.location}
          </div>
        )}
      </div>

      {event.description && <p className="mt-8 text-zinc-300 whitespace-pre-line leading-relaxed text-lg">{event.description}</p>}

      {event.url && (
        <a href={event.url} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-lg btn-crimson font-semibold" data-testid="event-link-external">
          Mais informações <ArrowSquareOut size={16} weight="bold" />
        </a>
      )}
      <InteractionsPanel entityType="events" entityId={id} />
    </div>
  );
}
